<template>
  <select
      :value="value"
      name="reviewers"
      class="leave-review-reviewers-select__select"
      @change="handleChange"
    >
    <option
      v-for="reviewer in reviewers"
      :key="reviewer.user_id"
      :value="reviewer.user_id"
    >
      {{ reviewer.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'LeaveReviewReviewersSelect',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    inspection: {
      type: Object,
      required: true,
    },
  },

  computed: {
    reviewers() {
      return []
        .concat(this.inspection.attributes.buyer?.data?.attributes || [])
        .concat(this.inspection.attributes.buyer_2?.data?.attributes || [])
        .concat(this.inspection.attributes.buying_agent?.data?.attributes || [])
    },
  },

  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style lang="scss">
.leave-review-reviewers-select {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &__label {
    font-size: 0.875rem;
    color: #6b7280;
    font-weight: bold;
  }

  &__select {
    display: block;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    padding: 0.5rem 0.75rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    font-size: 0.875rem;
    color: #374151;

    &:focus {
      border-color: #3b82f6;
      outline: none;
      box-shadow: 0 0 0 1px #3b82f6;
    }

    &::placeholder {
      font-style: italic;
      color: #9ca3af;
    }
  }

  &__option {
    font-size: inherit;
  }
}

</style>